import { origins } from './constants';

const { PI } = Math;

type ValueOf<T> = T[keyof T];

interface IGetRangesParams {
  index: number;
  origin: string;
  rotationAngle: number;
  diagonalAngle: number;
}

const angleTo2PIRange = (angle: number): number => (angle > 2 * PI ? angle - 2 * PI : angle);

export const needsRatio = (origin: ValueOf<typeof origins>) => origin.includes('-');

const negateDiagonalForOrigins = [origins.topRight, origins.bottomLeft];

// calculating in terms of 0 to 259 deg
export const transformAngle = (angle: number) => {
  const smallAngle = angle % 360;
  const addToMakePositive = Number(smallAngle < 0) * 360; // add 360 if angle is negative
  return smallAngle + addToMakePositive;
};

/*
   This function is providing the angle ranges when the cropping must be positive. Positive cropping means we need to
   increase the crop area(the net). As the cursor is in 0-360 horizontaly from left to right, this function will bring all
   the angles to that range. There are 3 cases:
   - The angle resizers top-left and right-bottom need to be positive from (-diagonal) of rect to (-diagonal + PI)
   - The angle resizers which are at the bottom also have to take into account that rect is already rotated accross the horizontal so
    (+PI) to calculation must took place
   - The middle resizers are starting from (0, PI) each differs from the last by (PI / 2)

   NOTE that the rect itself can be rotated so (+rotation) anyway.
 */
export const getRanges = ({ index, origin, rotationAngle, diagonalAngle }: IGetRangesParams) => {
  const additionalAngle = origin.includes(origins.bottom) ? PI : 0;
  const isDiagonalBased = needsRatio(origin);
  const negationPointDiagonal = negateDiagonalForOrigins.includes(origin) ? 1 : -1;
  const minAngle = angleTo2PIRange(rotationAngle + (isDiagonalBased ? negationPointDiagonal * diagonalAngle + additionalAngle : (index * PI) / 4));
  const maxAngle = minAngle + PI;
  if (minAngle < 0) {
    return [
      [minAngle + 2 * PI, 2 * PI],
      [0, maxAngle],
    ];
  }
  if (maxAngle > 2 * PI) {
    return [
      [minAngle, 2 * PI],
      [0, maxAngle - 2 * PI],
    ];
  }
  return [[minAngle, maxAngle]];
};

export const degreeToRadian = (degrees: number) => (degrees * Math.PI) / 180;
